export const CHANGE_SUBJECT_SELECTED = 'changeSubjectSelected';
export const COMMIT_CHANGE_SUBJECT_SELECTED = 'subject/changeSubjectSelected';
